import { render, staticRenderFns } from "./ProfileSettingsModule.vue?vue&type=template&id=0f008da3&scoped=true&"
import script from "./ProfileSettingsModule.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsModule.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingsModule.vue?vue&type=style&index=0&id=0f008da3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f008da3",
  null
  
)

export default component.exports